module.exports = __webpack_public_path__ + "d1d5ead055dc3b1bf9c3932c1673cf78.pdf";